module.exports = __webpack_public_path__ + "static/media/btn_parents_03_blog_video.370279d3.png";